export class CarService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    saveCar(car, clientId) {
        const carsJson = localStorage.getItem('cars');
        const carsMap = new Map(carsJson ? JSON.parse(carsJson) : []);
        if (!carsMap.has(clientId)) {
            carsMap.set(clientId, []);
        }
        const clientCars = carsMap.get(clientId);
        const indexCar = clientCars.findIndex(c => c.plate == car.plate);
        if (indexCar != -1) {
            clientCars.splice(indexCar, 1);
        }
        clientCars.push(car);
        localStorage.setItem('cars', JSON.stringify([...carsMap]));
    }
    getCar(plate, clientId) {
        let carMap = localStorage.getItem('cars') ? JSON.parse(localStorage.getItem('cars')) : null;
        if (!carMap) {
            return null;
        }
        const clientCars = carMap.get(clientId);
        if (!clientCars) {
            return null;
        }
        const car = [...clientCars.values()].find(p => p.id == clientCars);
        return car ? car : null;
    }
    getAllCars(clientId) {
        const carsJson = localStorage.getItem('cars');
        const carsMap = new Map(carsJson ? JSON.parse(carsJson) : []);
        const carsList = carsMap ? carsMap.get(clientId) : [];
        return carsList;
    }
}
